<template>
  <Form :model="formItem" :label-width="80">
    <Row>
      <Col span="24">
      <FormItem label="选项切换">
        <RadioGroup v-model="defaultLabel" @on-change="onRadioGroupChange">
          <Radio :label="categoryName" border></Radio>
          <Radio :label="taxName" border></Radio>
          <Radio :label="industryName" border :style="{display:isShowIndustry?'inline-block':'none'}"></Radio>
          <!-- <Radio :label="industryName" border :style="{display:isShowIndustry&&isCityVersion?'inline-block':'none'}"></Radio> -->
        </RadioGroup>
      </FormItem>
      </Col>
    </Row>
    <Row>
      <Col span="24">
      <FormItem label="优惠税种">
        <SingleSelect class="common-width" ref="taxSelector" @onClearText="onTaxClearText" @tag-Select="getTaxesSelection"></SingleSelect>
      </FormItem>
      </Col>
    </Row>
    <Row>
      <Col span="24">
      <FormItem label="优惠项目">
        <SingleSelect class="common-width" ref="categorySelector" @onClearText="onCategoryClearText" @tag-Select="getCategorySelection"></SingleSelect>
      </FormItem>
      </Col>
    </Row>
    <Row>
      <Col span="24">
      <FormItem label="优惠行业" :style="{display:isShowIndustry?'block':'none'}">
        <SingleSelect class="common-width" ref="industrySelector" @onClearText="onIndustryClearText" @tag-Select="getIndustrySelection"></SingleSelect>
      </FormItem>
      </Col>
    </Row>
    <FormItem label="文件效力">
      <SingleSelect class="common-width" :tData="sTreeData2" @onClearText="onForceClearText" @tag-Select="getForceSelection"></SingleSelect>
    </FormItem>
    <FormItem>
      <Button type="primary" icon="ios-search" size="default" @click="Submit()">查询</Button>
    </FormItem>
  </Form>
</template>
<script>
import SelectData from '../../../assets/json/selectData.json'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import ForeignTrade from './foreign_trade_category.vue'
import TreeSingleselect from '../../common/tree-single-select.vue'
import treeData2 from '../../../assets/json/select-tree2.json'
import store from '../../../store/'
export default {
  name: "TaxBreak",
  inject: ['expand'],
  data() {
    return {
      formItem: {
        inputfilename: '',
        inputnumber: '',
        inputothers: '',
        categoryselected: [], //税收优惠
        taxSelected: [], //税种
        industrySelected: [], //税收优惠行业
        switch: true,
        da: [],
        fileforce: SelectData.fileforce,
      },
      industry: SelectData.foreigntaxcategory,
      cList: SelectData.foreigntax,
      model11: [],
      // sTreeData: this.getSelectTreeData(),
      sTreeData2: this.getSelectTreeData2(),
      defaultLabel: "税收优惠项目",
      taxName: "税收优惠税种",
      categoryName: "税收优惠项目",
      industryName: "税收优惠行业",
      categoryDisabled: false,
      taxDisabled: false,
      isShowIndustry:true,
      isCityVersion:store.state.user.initData.currentVersion==='1'?true:false,
      //prefixCode: "000002",

    }
  },
  methods: {
    onRadioGroupChange(value) {
      //console.log("onRadioGroupChange:" + value)
      if (value === this.taxName) {
        this.$refs.categorySelector.setValue(null)
        this.$refs.industrySelector.setValue(null)
        this.$refs.categorySelector.setDisabled(true)
        this.$refs.industrySelector.setDisabled(true)
        this.$refs.taxSelector.setDisabled(false)
        this.onCategoryClearText()
        this.onIndustryClearText()
      } else if (value === this.categoryName) {
        this.$refs.taxSelector.setValue(null)
        this.$refs.industrySelector.setValue(null)
        this.$refs.taxSelector.setDisabled(true)
        this.$refs.industrySelector.setDisabled(true)
        this.$refs.categorySelector.setDisabled(false)
        this.onTaxClearText()
        this.onIndustryClearText()
      } else if (value === this.industryName) {
        this.$refs.taxSelector.setValue(null)
        this.$refs.categorySelector.setValue(null)
        this.$refs.taxSelector.setDisabled(true)
        this.$refs.categorySelector.setDisabled(true)
        this.$refs.industrySelector.setDisabled(false)
        this.onTaxClearText()
        this.onCategoryClearText()
      }

    },
    ButtonGroupSelect(id) {
      var item = this.formItem.fileforce[id];
      item.Selected = !item.Selected;
      if (item.Selected == true) {
        item.type = "primary";
      } else {
        item.type = "default";
      }

    },
    getFormattedDate(date) {
      var year = date.getFullYear();
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;
      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      return year + '-' + month + '-' + day;
    },
    timeOnChange() {
      var time = []
      if (this.formItem.da[0] !== "") {
        time[0] = this.getFormattedDate(this.formItem.da[0])
        time[1] = this.getFormattedDate(this.formItem.da[1])
        this.formItem.da = time
      } else {

      }
    },
    Submit() {

      if (this.sliderLength >= 2) {
        this.screenSet(true);
      }
      //如果用户选择的是行业需要显示通用和专属
      var t = 0 //t=1,税收优惠税种,t=2税收优惠项目,t=3税收优惠行业
      if (this.defaultLabel === this.industryName) {
        t = 3
        this.$emit('onTaxBreakSearch', this.formItem, t)
      } else if (this.defaultLabel === this.taxName) {
        t = 1
        this.$emit('onTaxBreakSearch', this.formItem,t)
      } else if (this.defaultLabel === this.categoryName) {
        t = 2
        this.$emit('onTaxBreakSearch', this.formItem,t)
      }


      //console.log(this.defaultLabel)
      //console.log(this.formItem)

    },
    ...mapMutations([
      'screenSet', 'setSliderLength'
    ]),
    getSelectTreeData() {
      return treeData2.trade
    },
    getSelectTreeData2() {
      return treeData2.force
    },
    propDataInit(data, placeholder, searchable) {
      var a = {}
      a.data = data
      a.placeholder = placeholder
      a.searchable = searchable
      return a
    },
    getTaxesSelection(node) {
      //this.formItem.taxSelected = node
      this.formItem.categoryselected = node
    },
    getCategorySelection(node) {
      this.formItem.categoryselected = node
    },
    getIndustrySelection(node) {
      //拼接kcode
      // var n =node
      // n.value=this.prefixCode+node.value
      // n.id=this.prefixCode+node.id
      this.formItem.categoryselected = node
    },
    onCategoryClearText() {
      this.formItem.categoryselected = {}
    },
    onTaxClearText() {
      this.formItem.categoryselected = []
    },
    onIndustryClearText() {
      //console.log("1111111111111111111")
      this.formItem.categoryselected = []
    },
    getForceSelection(node) {
      this.formItem.fileforce = node
    },
    onForceClearText() {
      this.formItem.fileforce = {}
    },
    bindCategory() {
      //console.log(this.sta)
      let obj = this.propDataInit(this.sta.initData.reduction, this.categoryName, false)
      this.categoryselected = obj
      this.$refs.categorySelector.bindData(obj)
    },
    bindTaxes() {
      let obj = this.propDataInit(this.sta.initData.reductionTax, this.taxName, false)
      this.taxSelected = obj
      this.$refs.taxSelector.bindData(obj)
    },
    bindIndustry() {
      let obj = this.propDataInit(this.sta.initData.reductionIndustry, this.industryName, false)
      this.industrySelected = obj
      this.$refs.industrySelector.bindData(obj)
    }
  },
  mounted() {
    this.bindCategory()
    this.bindTaxes()
    this.bindIndustry()
    //默认关闭优惠项目
    this.onRadioGroupChange(this.defaultLabel)
  },
  computed: {
    ...mapGetters(['sliderLength', 'sliderScreen', 'reductionData', 'reductionTaxData', 'industryData', 'sta','getVersion'])
  },
  components: {
    'Trade': ForeignTrade,
    'SingleSelect': TreeSingleselect,
  },
  watch: {
    reductionData: function() {
      this.bindCategory()
    },
    reductionTaxData: function() {
      this.bindTaxes()
    }
  },

}

</script>
<style scoped>
body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.common-width {
  width: 300px;
}

</style>
